import { checkConditions } from '../package/packageUtils';

export const getCoverageRecommendationTitle = (coverageVariation,
  coverageList,
  coverageMerge,
  newCoverageCode,
  userData,
  product) => {
  let title = '';
  title = coverageList[newCoverageCode] && coverageList[newCoverageCode].recommendTitle ? coverageList[newCoverageCode].recommendTitle : '';
  if (coverageVariation && coverageVariation[newCoverageCode]) {
    // Do coverage variation based on conditions.
    coverageVariation[newCoverageCode]
      .filter(
        coverage => checkConditions(coverage.conditions,
          { ...userData, PRODUCT: product })
      )
      .forEach(
        coverage => {
          title = coverage.recommendTitle;
        }
      );
  }
  return title;
};